import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ListItemRendererComponent } from 'gung-list';
import { CommonModalService } from 'gung-common';
import { OttoOwnCrossReference } from '../../models/otto-olsen-cross-reference';
import { OttoOlsenCrossReferenceAdminService } from '../../services/otto-olsen-cross-reference-admin.service';
import { OttoOlsenCrossReferenceModalComponent } from '../otto-olsen-cross-reference-modal/otto-olsen-cross-reference-modal.component';

@Component({
  selector: 'otto-olsen-cross-reference-item',
  templateUrl: './otto-olsen-cross-reference-item.component.html',
  standalone: false
})
// ListLayoutMultipleComponent instantiates ONE renderer and assigns the whole batch to `data`,
// so this component receives OttoOwnCrossReference[] and renders all rows itself.
export class OttoOlsenCrossReferenceItemComponent extends ListItemRendererComponent<OttoOwnCrossReference[]> {
  deleteFailedId?: string;

  constructor(
    protected modalService: NgbModal,
    protected commonModalService: CommonModalService,
    protected adminService: OttoOlsenCrossReferenceAdminService
  ) {
    super();
  }

  edit(row: OttoOwnCrossReference): void {
    this.deleteFailedId = undefined;
    const ref = this.modalService.open(OttoOlsenCrossReferenceModalComponent, { size: 'lg' });
    ref.componentInstance.existing = { ...row };
    ref.result.then(() => {}, () => {});
  }

  remove(row: OttoOwnCrossReference): void {
    this.commonModalService
      .openConfirmYesNoModal(undefined, 'CONFIRM_DELETE_CROSS_REFERENCE', { size: 'sm' })
      .then(result => {
        if (result && row.id) {
          this.deleteFailedId = undefined;
          this.adminService.delete(row.id).subscribe({
            next: () => {},
            error: () => (this.deleteFailedId = row.id)
          });
        }
      });
  }
}
